const LISTE_SUIVI_ACHATS = {
  title: 'Liste suivi des achats',
  actions: {
    receptionner: 'Réceptionner',
    facturer: 'Facturer',
  },
  tabs: {
    code: 'N° Commande',
    dateDevisCommande: 'Date commande',
    fournisseur: 'Fournisseur',
    etat: 'Etat',
    montantHt: 'Montant HT',
    totalQuantite: 'Total quantité',
    receptionner: 'Réceptionner',
    facturer: 'Facturer',
  },
  tableLigneCommande: {
    libelle: 'Libellé ligne',
    produit: 'Produit',
    lieuDeLivraison: 'Lieu de livraison',
    quantite: 'Quantité',
    quantiteRapproche: 'Qté. rapprochée',
    quantiteResteARapprocher: 'Qté. reste à rapprocher',
    etatRapprochement: 'Etat rapprochement',
  },
  filtre: {
    dateCommande: 'Date de commande',
    fournisseur: 'Fourisseur(s)',
    code: 'N° Commande',
    etat: 'Liste des états',
    produits: 'Produits',
  },
  etatRapprochement: {
    nonRapproche: 'Non rapproché',
    rapprochePartiellement: 'Rapproché partiellement',
    rapproche: 'Rapproché',
  },
  receptionnerAllPopUpHeader: 'Réception de commande(s)',
  receptionnerAllPopUpDescription: 'Êtes-vous sûr de vouloir réceptionner cette(s) commande(s) ?',
  facturerAllPopUpHeader: 'Facturation de commande(s)',
  facturerAllPopUpDescription: 'Êtes-vous sûr de vouloir facturer cette(s) commande(s) ?',
  rececptionnerToolTipLabel: 'Au moins une des lignes a déjà été rapprochée.',
  facturerToolTipLabel: 'La commande est déjà facturée',
  messages: {
    success: {
      receptionner: 'Commande réceptionnée avec succès',
      facturer: 'Commande facturée avec succès',
    },
    errors: {
      commandeDejaReceptionner: 'La commande "{code}" est déjà réceptionnée',
    },
  },
};

export default LISTE_SUIVI_ACHATS;
